let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9HAaE")).then(() => parcelRequire('jIFjZ'));